import React, { useEffect, useState } from 'react'
import {Grid , Box, Button, IconButton, Divider} from '@mui/material';
import { Typography } from '@mui/material';
import financialServices from "../../images/financialServices.jpg"
import { makeStyles } from '@mui/styles'
import Grow from '@mui/material/Grow';
import { useRef } from "react";
import CloseIcon from '@mui/icons-material/Close';
import ATEA from "../../images/ATEA.png"
import APBSC from "../../images/APBSC.png"

const useStyles = makeStyles({
    root : {
        marginTop : "5%" , 
        backgroundColor : "white"
    },
    container : {
        paddingLeft : "1%" , 
        paddingRight : "1%"
    },
    imageItem : {
        paddingRight : "16px" , 
        position : "relative"
    } , 
    financialServicesImage : {
        height : "100%" , 
        width : "100%"
    } ,
    titleSection :{
        display : "flex" , 
        justifyContent : "center" , 
        direction : "rtl"
    },
    circle : {
        width : "100px" , 
        height : "100px" , 
        backgroundColor : "#009444" , 
        border : "1px solid #235F83" , 
        borderRadius: "50%" , 
        display : "flex" , 
        justifyContent : "center" , 
        alignItems : "center" , 
        // marginTop : "36px"
    } ,  
    growBox : {
        borderRadius : "4px" , 
        border : "1px solid gray" , 
        marginLeft : "1%" , 
        marginRight : "1%" , 
    } , 
    growRightSide : {
        width : "100%" , 
        backgroundColor : "#8BC43E" , 
        display : "flex" , 
        alignItems : "center" , 
        justifyContent : "center" , 
    } , 
    growHeader : {
        display : "flex" , 
        justifyContent : "space-between"
    } 
});

export default function FinancialServices() {

    const [showService, setShowService] = React.useState(false)

    const myRef = useRef(null)

    const [serviceHeight , setServiceHeight] = useState("0px")

    const [serviceMargin , setServiceMargin] = useState("0px")

    const [growContent, setGrowContent] = useState("")

    useEffect(()=>{
        if(serviceHeight === ""){
            myRef.current?.scrollIntoView({
                behavior: 'smooth'
              })
        }
    },[serviceHeight])

    const classes = useStyles();

    const openGrow = (contetn) => {
        setShowService(true) 
        setServiceHeight("") 
        setServiceMargin("24px")
        setGrowContent(contetn)
    }

    const closeGrow = () => {
        setShowService(false) 
        setServiceHeight("0px")  
        setServiceMargin("0px") 
        setGrowContent("")
    }

    const typographyStyles = {
        title_1 : {
            fontSize : "48px" , 
            fontWeight : 700 , 
            color : "black" , 
            fontFamily : "Vazir"
        } ,
        title_2 : {
            fontSize : "48px" , 
            fontWeight : 700 , 
            color : "blue", 
            marginRight : "16px" , 
            marginLeft : "16px" ,
            fontFamily : "Vazir"
        } ,
        financialServicesDescription : {
            direction : "rtl" , 
            textAlign : "justify" , 
            marginTop : "24px" , 
            lineHeight : "32px" , 
            fontFamily : "Vazir"
        } , 
        circleText : {
            color : "white" , 
            fontFamily : "Vazir" , 
            fontSize : "24px" , 
            fontWeight : 700 , 
            backgroundColor: 'transparent'
        } ,
        growRightSideText : {
            textAlign : "center" , 
            fontSize : "48px" , 
            fontWeight : 700 , 
            color : "white" , 
        } ,
        growHeaderTitle : {
            paddingRight : "16px" , 
            paddingTop : "16px" , 
            paddingBottom : "16px" , 
            color : "#235F83"
        } ,
        financialServicesDetail : {
            fontFamily : "Vazir" , 
            fontSize : "16px" , 
            fontWeight : 400 , 
            textAlign : "justify" ,  
            padding : "24px" , 
            lineHeight : "36px"
        } , 
    }

    const circleSection = {
        paddingLeft : "5%" , 
        display : "flex" , 
        flexDirection : "column" , 
        justifyContent : "space-between" , 
        paddingTop : "24px" , 
        paddingBottom : "24px"
    } 

    return (
        <div className={classes.root}>
            <Grid container className={classes.container} > 
                <Grid item xl={6} lg={6} md={6} sm={6} xs={6} className={classes.imageItem}>
                    <img src={financialServices} className={classes.financialServicesImage} />
                </Grid>
                <Grid item xl={4} lg={4} md={4} sm={4} xs={4} style={{position : "relative"}}>
                    <div className={classes.titleSection}>
                        <Typography sx={typographyStyles.title_1}>خدمات </Typography>
                        <Typography sx={typographyStyles.title_2}>نوآورانه</Typography>
                        <Typography sx={typographyStyles.title_1}> مالی</Typography>
                    </div>
                        <Typography sx={typographyStyles.financialServicesDescription}>
                            وسترا دیجیتال در صدد است با استفاده از خدمات نوین بانکداری و فرصت های فراهم شده در زیست بوم های بانکداری دیجیتال (با تمرکز بر زیست بوم سرزمین هوشمند پاد) این امکان را برای کسب و کار های نو پای حوزه کشاورزی فراهم کند تا نسبت به خلق الگو های کسب و کاری جدید و توسعه مقیاس فعالیت های خود مبادرت کنند . تعامل پذیری آسان خدمات مذکور در پلتفرم وسترا دیجیتال این امکان را برای کلیه بازیگران مذکور فراهم می کند تا با کمترین سرمایه گذاری بر روی زیر ساخت های موجود امکان بهره گیری از خدمات نوآورانه مالی و بانکی را در بستر ابری داشته باشند .
                        </Typography>
                </Grid>
                <Grid item xl={2} lg={2} md={2} sm={2} xs={2} sx={circleSection}>
                    <Box className={classes.circle}>
                        <Button onClick={() => openGrow("ATEA")}><Typography sx={typographyStyles.circleText}>ATEA</Typography></Button>
                    </Box>
                    <Box className={classes.circle} >
                        <Button onClick={() => openGrow("APBSC")}><Typography sx={typographyStyles.circleText}>APBSC</Typography></Button>
                    </Box>
                    <Box className={classes.circle} >
                        <Button onClick={() => openGrow("FC")}><Typography sx={typographyStyles.circleText}>FC</Typography></Button>
                    </Box>
                </Grid>
            </Grid>
            <Grow in={showService}><Box ref={myRef} className={classes.growBox} style={{height : serviceHeight ,marginTop : serviceMargin , marginBottom : serviceMargin}}>
                {growContent === "ATEA" ? 
                <Grid container style={{direction : "rtl"}}>
                    <Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
                        <Box className={classes.growRightSide} style={{height : "100%"}}>
                            <Typography sx={typographyStyles.growRightSideText}>ATEA</Typography>
                        </Box>
                    </Grid>
                    <Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
                        <div className={classes.growHeader}>
                            <Typography sx={typographyStyles.growHeaderTitle}>Agricultural Trade Escrow Account</Typography>
                            <IconButton style={{backgroundColor: 'transparent'}} onClick={closeGrow}><CloseIcon/></IconButton>
                        </div>
                        <Divider variant="middle" />
                        <Grid container spacing={2}>
                            <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                                <Typography sx={typographyStyles.financialServicesDetail}>حساب امانی تجارت کشاورزی، یک سرویس توافق مالی است. در این توافق دارایی یا پول طرفین معامله، توسط شخص ثالث در راستای منافع طرفین معامله نگهداری می‌شود. در واقع، مبلغ پرداختی توسط خریدار نزد شخص ثالث امانت می‌ماند و پس از اتمام معامله (در صورت تایید خریدار)، بلافاصله پول به حساب کشاورز منتقل می‌شود.</Typography>
                            </Grid>
                            <Grid item xl={6} lg={6} md={6} sm={6} xs={6} style={{marginTop : "20px" , textAlign : "center"}}>
                                <img src={ATEA} style={{ width : "75%"}} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                : growContent === "APBSC" ? 
                <Grid container style={{direction : "rtl"}}>
                    <Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
                        <Box className={classes.growRightSide} style={{height : "100%"}}>
                            <Typography sx={typographyStyles.growRightSideText}>APBSC</Typography>
                        </Box>
                    </Grid>
                    <Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
                        <div className={classes.growHeader}>
                            <Typography sx={typographyStyles.growHeaderTitle}>Agricultural Product Buyer/Seller Credit </Typography>
                            <IconButton style={{backgroundColor: 'transparent'}} onClick={closeGrow}><CloseIcon/></IconButton>
                        </div>
                        <Divider variant="middle" />
                        <Grid container spacing={2}>
                            <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                                <Typography sx={typographyStyles.financialServicesDetail}>تسهیلات پشتوانه، بدون نیاز به ضامن و وثیقه و بر مبنای اعتبارسنجی از حساب کاربری خریدار، فروشنده یا کشاورز به وی اعطا می‌شود. فرآیند دریافت آن، کاملا آنلاین بوده و تنها در چند دقیقه قابل ‌انجام است. با دریافت تسهیلات پشتوانه، مبلغی به عنوان «اعتبار خرید» در اختیار فرد قرار می‌گیرد که با استفاده از آن می‌تواند بدون محدودیت خرید کنید و بازپرداخت آن را بعدا، طی چند مرحله انجام دهد.</Typography>
                            </Grid>
                            <Grid item xl={6} lg={6} md={6} sm={6} xs={6} style={{marginTop : "20px" , textAlign : "center"}}>
                                <img src={APBSC} style={{ width : "75%"}} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                : growContent === "FC" ? 
                <Grid container style={{direction : "rtl"}}>
                    <Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
                        <Box className={classes.growRightSide} style={{height : "100%"}}>
                            <Typography sx={typographyStyles.growRightSideText}>FC</Typography>
                        </Box>
                    </Grid>
                    <Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
                        <div className={classes.growHeader}>
                            <Typography sx={typographyStyles.growHeaderTitle}>Farmer Card</Typography>
                            <IconButton style={{backgroundColor: 'transparent'}} onClick={closeGrow}><CloseIcon/></IconButton>
                        </div>
                        <Divider variant="middle" />
                        <Grid container spacing={2}>
                            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                                <Typography sx={typographyStyles.financialServicesDetail}>وسترا کارت به عنوان یک حساب کاملا الکترونیکی امکان انجام کلیه ی عملیات بانکی و مالی را برای کاربران زیست بوم وسترا فراهم می کند .</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid> : ""}
            </Box></Grow>  
        </div>
    )
}